var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserUpdateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E1D5D5",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8353 5.06859C10.6528 5.00768 10.4593 4.98698 10.268 5.00792C10.0768 5.02887 9.89233 5.09096 9.72733 5.18993L6.98067 6.83793C6.78323 6.95639 6.61984 7.12396 6.5064 7.32432C6.39295 7.52469 6.33333 7.75101 6.33333 7.98126V16.9373H5.66667C5.48986 16.9373 5.32029 17.0075 5.19526 17.1325C5.07024 17.2575 5 17.4271 5 17.6039C5 17.7807 5.07024 17.9503 5.19526 18.0753C5.32029 18.2004 5.48986 18.2706 5.66667 18.2706H17.6667C17.8435 18.2706 18.013 18.2004 18.1381 18.0753C18.2631 17.9503 18.3333 17.7807 18.3333 17.6039C18.3333 17.4271 18.2631 17.2575 18.1381 17.1325C18.013 17.0075 17.8435 16.9373 17.6667 16.9373H17V8.08393C16.9998 7.80428 16.9117 7.53177 16.7482 7.30494C16.5847 7.0781 16.3539 6.90843 16.0887 6.81993L10.8353 5.06859ZM9.66667 6.78193L7.66667 7.98193V16.9373H9.66667V6.78126V6.78193Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserUpdateIcon);
export default __webpack_public_path__ + "static/media/user-updateIcon.5dffbb7478115c5c05e523e79b863cb6.svg";
export { ForwardRef as ReactComponent };